var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5497 16.9481L31.5266 5.6001H29.1624L20.4995 15.4534L13.5804 5.6001H5.6001L16.0631 20.5L5.6001 32.4001H7.96444L17.1127 21.9947L24.4198 32.4001H32.4001L21.5492 16.9481H21.5497ZM18.3114 20.6313L17.2513 19.1476L8.81634 7.34167H12.4478L19.255 16.8694L20.3151 18.3531L29.1635 30.7377H25.5321L18.3114 20.6318V20.6313Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.b14762d5a55616eb1b4f5c8a899f042d.svg";
export { ForwardRef as ReactComponent };